module.exports.Person =

 class Person {
    constructor(forename, surname) {
        this.forename = forename;
        this.surname = surname;
    }

    invertedName() {
        return this.forename ? this.surname + ", " + this.forename : this.surname;
    }

    toString() {
        return (this.forename + " " + this.surname).trim();
    }
}
